import { useRef, useState } from 'react'
import { ImagePlus, X } from 'lucide-react'

// Campo de IMAGEM amigável: mostra a imagem (miniatura) e permite ENVIAR do computador.
// NÃO exibe caminho/URL. value = data URL (base64) ou URL existente. onChange(value).
export default function ImageField({ value, onChange }) {
  const inp = useRef(null)
  const [busy, setBusy] = useState(false)

  async function pick(e) {
    const file = e.target.files?.[0]
    if (!file) return
    setBusy(true)
    try {
      const dataUrl = await reduzir(file, 900, 0.82)
      onChange(dataUrl)
    } finally {
      setBusy(false)
      if (inp.current) inp.current.value = ''
    }
  }

  return (
    <div>
      {value ? (
        <div className="inline-block">
          <div className="relative">
            <img src={value} alt="" className="w-44 h-32 object-cover rounded-xl border border-gray-200" />
            <button type="button" onClick={() => onChange('')} title="Remover"
              className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border border-gray-200 shadow flex items-center justify-center text-gray-500 hover:text-red-600">
              <X size={14} />
            </button>
          </div>
          <button type="button" onClick={() => inp.current?.click()}
            className="block mt-1.5 text-xs text-accent-600 font-semibold hover:text-accent-700">
            {busy ? 'Processando…' : 'Trocar imagem'}
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => inp.current?.click()} disabled={busy}
          className="w-44 h-32 rounded-xl border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-400 hover:border-accent-400 hover:text-accent-500 transition-colors">
          <ImagePlus size={24} />
          <span className="text-xs mt-1">{busy ? 'Processando…' : 'Enviar imagem'}</span>
        </button>
      )}
      <input ref={inp} type="file" accept="image/*" className="hidden" onChange={pick} />
    </div>
  )
}

// Reduz e converte para data URL (mantém leve, sem servidor de arquivos).
function reduzir(file, max, q) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const img = new Image()
      img.onload = () => {
        let { width, height } = img
        if (width > max || height > max) {
          const r = Math.min(max / width, max / height)
          width = Math.round(width * r); height = Math.round(height * r)
        }
        const canvas = document.createElement('canvas')
        canvas.width = width; canvas.height = height
        canvas.getContext('2d').drawImage(img, 0, 0, width, height)
        try { resolve(canvas.toDataURL('image/jpeg', q)) } catch { resolve(reader.result) }
      }
      img.onerror = () => resolve(reader.result)
      img.src = reader.result
    }
    reader.onerror = () => resolve('')
    reader.readAsDataURL(file)
  })
}
